export default function isSame(v1, v2) {
    return String(v1) === String(v2);
}
